import { type AsociacionRequest, type AsociacionFormErrors } from '../types/asociacion';

export class AsociacionValidation {
  public static validateAsociacion(asociacion: AsociacionRequest): AsociacionFormErrors {
    const errors: AsociacionFormErrors = {};

    // Required field validations
    if (!asociacion.descripcion?.trim()) {
      errors.descripcion = 'Descripción es requerida';
    } else if (asociacion.descripcion.trim().length < 3) {
      errors.descripcion = 'Descripción debe tener al menos 3 caracteres';
    } else if (asociacion.descripcion.trim().length > 100) {
      errors.descripcion = 'Descripción no puede exceder 100 caracteres';
    }

    if (!asociacion.idProcedencia) {
      errors.idProcedencia = 'Procedencia es requerida';
    }

    return errors;
  }

  public static isValidAsociacion(asociacion: AsociacionRequest): boolean {
    const errors = this.validateAsociacion(asociacion);
    return Object.keys(errors).length === 0;
  }
}